import React from 'react';
import ReactDOM from 'react-dom/client';
import { ConfigProvider, theme } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import App from './App';
import './styles.css';
import './editor-workspace.css';
import './video-editor-workspace.css';
import './focused-segment-editor.css';
import './focused-video-editor.css';
import './focused-storyboard-editor.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ConfigProvider locale={zhCN} variant="outlined" theme={{
      algorithm: theme.darkAlgorithm,
      token: {
        colorPrimary: '#73d9be', colorInfo: '#86bfe8', colorText: '#e6edef',
        colorTextSecondary: '#9ba9b1', colorTextTertiary: '#7c8c95', colorTextQuaternary: '#53626a',
        colorSuccess: '#73d9be', colorWarning: '#e8bc6c', colorError: '#ef9292',
        colorBgBase: '#171d22', colorBgLayout: '#171d22', colorBgElevated: '#293137',
        colorBgContainer: '#20282e', colorBorder: '#3a454c', colorSplit: '#343e45',
        borderRadius: 6, borderRadiusLG: 8, fontSize: 13, controlHeight: 32,
        boxShadow: 'none', boxShadowSecondary: 'none',
        fontFamily: '"Segoe UI", "Microsoft YaHei", system-ui, sans-serif',
      },
      components: {
        Button: { primaryColor: '#11251f', colorPrimary: '#73d9be', colorPrimaryHover: '#92e8d0', borderRadius: 6 },
        Table: { headerBg: '#252e34', headerColor: '#c8d4da', rowHoverBg: '#2b373d', borderColor: '#364149' },
        Tabs: { itemColor: '#9ba9b1', itemSelectedColor: '#8ce4cc', inkBarColor: '#73d9be' },
        Card: { headerFontSize: 14, headerHeight: 44 },
      },
    }}>
      <App />
    </ConfigProvider>
  </React.StrictMode>,
);
